export default function PartnersSection() {
    const partners = [
      {
        name: "Brightway Energy Group",
        logo: "https://res.cloudinary.com/dpkn1ppzj/image/upload/v1770043237/81247d63506a98438d58c973d95ec15d1dc684f5_p5qvox.png",
        logoWidth: 176,
        logoHeight: 72,
        description: "Brightway Energy Group, Global operations in China, India, Russia, and the United States. Leaders in solids control and drilling waste management with advanced equipment for oil, gas, shale, CBM, geothermal drilling, and environmental waste treatment.",
      },
      {
        name: "Lanzhou LS Group",
        logo: "https://res.cloudinary.com/dpkn1ppzj/image/upload/v1770043237/e9b306d8d9f12f5252fe476f33520373e080b4bb_aiejpv.png",
        logoWidth: 225,
        logoHeight: 80,
        description: "Lanzhou LS Group. One of China's oldest and most advanced oilfield equipment manufacturers with over 70 years of innovation. Workforce of 8,000+ delivering complete rig systems including 40+ deep drilling rigs and 16+ offshore packages in the past three years.",
      },
      {
        name: "CNPC",
        logo: "https://res.cloudinary.com/dpkn1ppzj/image/upload/v1770043236/677b600490cc6e5e8d4a3105e9b578780b6c04ea_vwre8x.png",
        logoWidth: 208,
        logoHeight: 96,
        description: "Brightway Energy Group, The largest specialized pipe manufacturer under CNPC and birthplace of welded pipes in China. Founded in 1958, leaders in OCTG, line pipe, coiled tubing, and advanced energy solutions with annual capacity exceeding 3.57 million tons.",
      },
    ];
  
    return (
      <section className="py-[30px] lg:py-[60px]">
        <div className="max-w-7xl mx-auto 2">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">
            {partners.map((partner, index) => (
              <div 
                key={index} 
                className="bg-white p-8 rounded-lg border-r transition-shadow"
              >
                {/* Logo in fixed-height area so spacing to name is consistent */}
                <div className="h-24 flex items-center mb-6">
                  <img
                    src={partner.logo}
                    alt={partner.name}
                    width={partner.logoWidth}
                    height={partner.logoHeight}
                    className="object-contain max-h-24"
                  />
                </div>
                
                {/* Company name (hidden if shown in logo) */}
                <h3 className="text-xl font-bold text-slate-900 mb-4">
                  {partner.name}
                </h3>
                
                {/* Description */}
                <p className="text-sm text-gray-600 leading-relaxed">
                  {partner.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }